// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fRGqV","content":"styles_content__3Jooy"};